"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageValidation = exports.packageHandler = exports.definitions = void 0;
const contentful = __importStar(require("./contentful"));
const slack = __importStar(require("./slack"));
const stripe = __importStar(require("./stripe"));
const weatherbit = __importStar(require("./weatherbit"));
const crunchbase = __importStar(require("./crunchbase"));
const salesforce = __importStar(require("./salesforce"));
const twitter = __importStar(require("./twitter"));
const ipApi = __importStar(require("./ip-api"));
const handlers = [contentful, slack, stripe, weatherbit, crunchbase, salesforce, twitter, ipApi];
const definitions = handlers.reduce((result, handler) => ({ ...result, ...handler.definitions }), {});
exports.definitions = definitions;
const packageHandler = handlers.reduce((result, handler) => ({ ...result, [handler.packageName]: handler.handler.name }), {});
exports.packageHandler = packageHandler;
const packageValidation = handlers.reduce((result, handler) => ({ ...result, [handler.packageName]: handler.validate }), {});
exports.packageValidation = packageValidation;
//# sourceMappingURL=index.js.map